import React from "react";
import classNames from 'classnames';
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as Style from "./customerOverview.module.less"
import ResponsiveCarousel from "../responsive-carousel"
import {useTranslation} from "gatsby-plugin-react-i18next";
import Pane from "../pane/pane";
import PaneTitle from "../pane/pane-title/pane-title";
import Marquee from "react-fast-marquee";

function renderCustomerNode(node) {
	if (!node.frontmatter.imagePath) {
		return null; // No image data at all
	}

	const image = getImage(node.frontmatter.imagePath);
	const publicURL = node.frontmatter.imagePath.publicURL;

	if (image) {
		// Use gatsby-plugin-image GatsbyImage for processed images
		return (
			<div key={node.id}>
				<div className={Style.customer}>
					<GatsbyImage
						className={Style.image}
						fadeIn={false}
						loading={"eager"}
						imgStyle={{ objectFit: "contain" }}
						alt={node.frontmatter.name}
						image={image}
					/>
				</div>
			</div>
		);
	} else if (publicURL) {
		// Use regular img tag for SVGs or other direct URLs
		return (
			<div key={node.id}>
				<div className={Style.customer}>
					<img
						className={Style.image}
						src={publicURL}
						alt={node.frontmatter.name}
						loading="eager"
						style={{ objectFit: "contain", width: "100%"}}
					/>
				</div>
			</div>
		);
	}
	return null; // Fallback if neither image nor publicURL is usable
}

function rearrangeArray(arr, quarterNumber = 1) {
	const quarterLength = Math.floor(arr.length / 4)
	const firstQuarter = arr.slice(0, quarterLength)
	const secondQuarter = arr.slice(quarterLength, 2 * quarterLength + 2)
	const thirdQuarter = arr.slice(2 * quarterLength + 2, 3 * quarterLength + 2)
	const fourthQuarter = arr.slice(3 * quarterLength + 2)
	switch (quarterNumber) {
		case 1:
			return firstQuarter
		case 2:
			return secondQuarter
		case 3:
			return thirdQuarter
		case 4:
			return fourthQuarter
		default:
			return arr
	}
}

export const CustomerOverview = ({ data: items, overwriteWidth, useMarquee = false,
									 backgroundColor = "#fff",
	isFontColorWhite
}) => {
	const { t } = useTranslation()
	const speed = 20
	const data = items.filter(({ node }) => node.frontmatter.imagePath)
	return (
		<Pane
			noPadding
			bgColor={backgroundColor}
		>
			<div className={ classNames(Style.viewwidth, Style.wrapper, {
				[Style.overwriteWidth]: overwriteWidth
			}) }>
				<PaneTitle
					title={ t("customers.ourCustomers") }
					description={ t("customers.ourCustomersDescription") }
					isCentered
					isWhite={isFontColorWhite}
				/>
				<div className={ Style.customers }>
				{
					useMarquee ? (
						<div className={Style.marqueeContainer} style={{ "--grad-color": backgroundColor }}>
							<Marquee
								autoFill
								speed={speed}
							>
								{ rearrangeArray(data, 1).map(({ node }) => (
									node.frontmatter.imagePath && (
										renderCustomerNode(node)
									)
								)) }
							</Marquee>
							<Marquee
								autoFill
								direction="right"
								speed={speed}
							>
								{ rearrangeArray(data, 2).map(({ node }) => (
									node.frontmatter.imagePath && (
										renderCustomerNode(node)
									)
								)) }
							</Marquee>
							<Marquee
								autoFill
								speed={speed}
							>
								{ rearrangeArray(data, 3).map(({ node }) => (
									node.frontmatter.imagePath && (
										renderCustomerNode(node)
									)
								)) }
							</Marquee>
							<Marquee
								autoFill
								direction="right"
								speed={speed}
							>
								{ rearrangeArray(data, 4).map(({ node }) => (
									node.frontmatter.imagePath && (
										renderCustomerNode(node)
									)
								)) }
							</Marquee>
						</div>
					)
					: (
						<ResponsiveCarousel
							shouldAutoPlay
						>
							{ data.map(({ node }) => (
								node.frontmatter.imagePath && (
									renderCustomerNode(node)
								)
							)) }
						</ResponsiveCarousel>
					)
				}
				</div>
			</div>
		</Pane>
	);
};

export default CustomerOverview
